import { Suspense, type FunctionComponent } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

interface LazyPluginPopoverDatetimeProps {
  callback: (args: {
    el: HTMLAnchorElement | HTMLButtonElement;
    options: { date: string };
  }) => Promise<void>;
  type: 'date' | 'datetime';
  date?: Date;
  minDate?: Date;
  maxDate?: Date;
}

export const LazyPluginPopoverDatetime: FunctionComponent<
  LazyPluginPopoverDatetimeProps
> = ({ callback, type, date, minDate, maxDate }) => {
  const NewPluginPopoverDatetime = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "NewPluginPopoverDatetime" */ 'app/src/components/Plugins/PluginPopover/NewPluginPopoverDatetime'
      ),
    { namedImport: 'NewPluginPopoverDatetime' },
  );
  return (
    <ErrorBoundary>
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <NewPluginPopoverDatetime
            callback={callback}
            type={type}
            date={date}
            minDate={minDate}
            maxDate={maxDate}
          />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
